const BoostTypes = {
  ADD_BOOST_WORDS_REQUEST: 'boost/ADD_BOOST_WORDS_REQUEST',

  SET_ADD_BOOST_WORDS_SUCCESS: 'boost/SET_ADD_BOOST_WORDS_SUCCESS',
  SET_ADD_BOOST_WORDS_LOADING: 'boost/SET_ADD_BOOST_WORDS_LOADING',

  DELETE_BOOST_WORD_REQUEST: 'boost/DELETE_BOOST_WORD_REQUEST',

  SET_BOOST_WORDS: 'boost/SET_BOOST_WORDS',
};

export default BoostTypes;
